import { AnyAction } from 'redux';
import { call, select, takeLatest } from 'redux-saga/effects';
import {
  GlobalAction,
  GlobalActions,
  GlobalPut,
  WrappedSavedStatesLoaded,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';

export function* updateDashboardTierartAfterLoadSaga() {
  yield takeLatest(GlobalActions.SAVED_STATES_LOADED, safeSaga(update, App.TKV_V2));
}

export function* update(action: AnyAction) {
  const state: IAppState = yield select();
  if (!wasOwnStateRestored(action, state.angebotsId)) {
    return;
  }

  const globalPut = GlobalPut.getInstance();
  yield call(
    [globalPut, globalPut.put],
    new GlobalActions().updateDashboardAfterLoadAzam({
      appId: App.TKV_V2,
      angebotsId: state.angebotsId,
      tierart: state.versicherungsnehmer.animalType,
    }),
  );
}

function wasOwnStateRestored(action: AnyAction, angebotsId: string): boolean {
  const payload = (action as GlobalAction<WrappedSavedStatesLoaded>)?.payload;
  return !!payload?.savedStatesLoaded?.some(
    savedState => savedState.appId === App.TKV_V2 && savedState.angebotsId === angebotsId,
  );
}
